/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Panel_RetryInputs */

const en_tasks_panel_retry = /** @type {(inputs: Tasks_Panel_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retry`)
};

const fr_tasks_panel_retry = /** @type {(inputs: Tasks_Panel_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réessayer`)
};

const ms_sg2_tasks_panel_retry = /** @type {(inputs: Tasks_Panel_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuba semula`)
};

/**
* | output |
* | --- |
* | "Retry" |
*
* @param {Tasks_Panel_RetryInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const tasks_panel_retry = /** @type {((inputs?: Tasks_Panel_RetryInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Panel_RetryInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_panel_retry(inputs)
	if (locale === "fr") return fr_tasks_panel_retry(inputs)
	return ms_sg2_tasks_panel_retry(inputs)
});